import Dropzone, { IFileWithMeta, StatusValue } from 'react-dropzone-uploader';
import { Controller, useFormContext } from 'react-hook-form';
import './ControlledDropFiles.scss';
import 'react-dropzone-uploader/dist/styles.css';
import { ReactNode } from 'react';
const MAX_FILE_SIZE_IN_BYTES = 2097152;

function ControlledDropFiles({ label, name }: { label: ReactNode; name: string }) {
  const { control } = useFormContext();

  const handleControlledDropzoneChangeStatus = (status: StatusValue, allFiles: IFileWithMeta[], setFiles: Function) => {
    setTimeout(() => {
      if (['done', 'removed'].includes(status)) {
        setFiles([...allFiles]);
      }
    }, 0);
  };

  function validateFileSize(filelist: any[]) {
    if (!filelist || !filelist.length) return true;

    let totalSize = 0;
    filelist.forEach(each => totalSize += each.file.size)

    return totalSize <= MAX_FILE_SIZE_IN_BYTES;
  }
  
  return (
    <div className="controlled-drop-files">
      <Controller
        control={control}
        name={name || 'pictures' as any}
        // rules={{validate: { maxFileSize: value => validateFileSize(value) || 'The total files size should be less than 2MB.' } }}
        render={({ field: { onChange } }) => (
          <Dropzone
            canRemove={true}
            inputContent={label}
            accept="image/*"
            onChangeStatus={(file, status, allFiles) => {
              handleControlledDropzoneChangeStatus(status, allFiles, onChange);
            }}
          />
        )}
      />
    </div>
  );
}
export default ControlledDropFiles;
